import ObjPropParser from "@/classes/ObjPropParser";
import ParentComms from "@/classes/ParentComms";
import Lytics from "@/classes/Lytics";
import {merge} from "lodash";

const config = {};

async function mergeConfigs(files) {
	let o = {};
	for(let i in files) {
		const config = await fetch(`/config/${files[i]}`);
		const json = await config.json();
		o = merge(o, json);
	}
	return o;
}

export default class {
	static async LoadConfig(conf, arg = '') {
		try{
			if(arg)arg = `-${arg}`
			const ver= Math.random();
			const files = this.AppConf?.flyerConfig?.merge?.files;

			if(files){
				const _config = await mergeConfigs(files);
				config[conf] = _config;
				return _config;
			}
			const _config = await fetch(`/config/${conf}${arg}.json?v=${ver}`);
			const json = await _config.json();
			config[conf] = json;
			return json;
		} catch (e) {
			console.log(`Config File '${conf} failed to load.`, e);
		}
	}
	static get AppConf() {
		return config['app'];
	}

	static ParseEvent(events = {}, data = null) {
		for(let p in events) {
			const eventData = ObjPropParser.Parse(events[p] , data);
			switch(p) {
				case 'postMessage':
					//console.log('ParseEvent PostMessage:', data)
					ParentComms.SendData(eventData);
				break;
				case 'analytic':
					Lytics.TriggerEvent(eventData.event, eventData.data)
				break;
			}
		}

	}
}
